if (!window._babelPolyfill) {
  require('babel-polyfill');
}
import InitModule from './InitModule';

let version = '1.4.0';

export function info() {
  console.log(`Aperza Dynamic Widget: ${version}`);
}

export function init() {
  InitModule.init();
}

// export function registerIFrame(iframe) {
//   InitModule.appearInsElement(iframe)
// }

(function () {

  if (!window.aperzaDynamicWidget) {
    //console.log(`Aperza Dynamic Widget Init`);
    window.aperzaDynamicWidget = true;
    window.aperzaDynamicWidgetVersion = version;
    init();
  } else {
    //console.log(`Aperza Dynamic Widget SKIP Init`);
  }

})();
